// @flow
import React, { Component } from 'react';
import Modal from '@localytics/loc-components/lib/Modal';
import Button from '@localytics/loc-components/lib/Button';
import TextSubmitForm from '@localytics/loc-components/lib/TextSubmitForm';
import withLeaveDialog from './withLeaveDialog';
import './stylesheets/CampaignNameModal.scss';

type CampaignNameModalProps = {
  campaignName: string,
  showModal: boolean,
  onCloseCallback: Function,
  orgId: number,
  orchestrationId: number,
  updateOrchestrationName: Function
};

type Option = {
  label: string,
  value: number
};

type State = {
  selectedValue: Option | null
};

class CampaignNameModal extends Component<CampaignNameModalProps, State> {
  submitInputValue: Function = (input: string) => {
    const { orgId, orchestrationId } = this.props;
    let name = input;
    if (input === '') {
      name = this.props.campaignName;
    }
    // TODO: Switch from dispatch and then callback once actions are real
    this.props.onCloseCallback();
    this.props.updateOrchestrationName(orgId, orchestrationId, name);
  };

  focusInput: Function = div => {
    if (div) {
      const input = div.getElementsByTagName('input')[0];
      input.select();
    }
  };

  render() {
    const ModalWithLeaveDialog = withLeaveDialog(Modal);
    return (
      <ModalWithLeaveDialog
        className="CampaignNameModal"
        show={this.props.showModal}
        onHide={this.props.onCloseCallback}
      >
        <div className="CampaignNameModal__Content" ref={this.focusInput}>
          <div className="CampaignNameModal__Content__Title">
            Name your workflow
          </div>
          <TextSubmitForm
            submitInputValue={this.submitInputValue}
            initialValue={this.props.campaignName}
            allowEmptySubmitValue
            className="TextSubmitForm--large CampaignNameModal__Content__Input"
          >
            <div className="CampaignNameModal__Content__Buttons">
              <Button
                buttonType="button"
                size="large"
                label="Cancel"
                tabIndex={-1}
                onClick={this.props.onCloseCallback}
              />
              <Button
                buttonType="submit"
                type="primary"
                size="large"
                label="Save Changes"
                tabIndex={-1}
              />
            </div>
          </TextSubmitForm>
        </div>
      </ModalWithLeaveDialog>
    );
  }
}

export default CampaignNameModal;



// WEBPACK FOOTER //
// ./src/components/CampaignNameModal.jsx